import api from "@/lib/api";

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export const safeName = (s) => (s || "agreement").replace(/[^a-z0-9]+/gi, "-");
